import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TextComponent} from './text.component';
import {TagTextModule} from '../tag-text/tag-text.module';
import { EvaButtonModule } from '../eva-button/eva-button.module';


@NgModule({
    declarations: [
        TextComponent
    ],
    imports: [
        CommonModule,
        TagTextModule,
        EvaButtonModule
    ],
    exports: [
        TextComponent
    ]
})
export class TextModule {
}
